import React, { Fragment } from 'react'
import { Menu } from 'antd';
import {AppLogin}from './app/AppLogin'
import {AppGetHouse}from './sap/AppGetHouse'
import './PosApi.less'
import {AppPopover} from 'qcc'
import { AppGetFee } from './app/AppGetFee';
import { AppGetChinaPayRefKey } from './app/AppGetChinaPayRefKey';
import { AppGetFund } from './app/AppGetFund';
import { AppGetProject } from './app/AppGetProject';
import { AppGetFqList } from './app/AppGetFqList';
import { AppGetDyList } from './app/AppGetDyList';

import { SapGetBank } from './sap/SapGetBank';
import { SapGetCustomerList } from './sap/SapGetCustomerList';
import { SapGetTrade } from './sap/SapGetTrade';
import {Statement} from './app/Statement';


export const PosApi = () =>{

const[current,setCurrent] = React.useState('sapbank');

const renderDemo = () =>{
    switch (current){
        case 'appLogin':
            return <AppLogin />;
      
        case 'getFee':
            return<AppGetFee/>;
        case 'getChinaPayRefKey':
            return <AppGetChinaPayRefKey/>;
        case 'getFund':
            return <AppGetFund/>
        case 'getProject':
            return <AppGetProject />
        case 'getFqList':
            return <AppGetFqList/>
        case 'getDyList':
            return<AppGetDyList/>

        case 'saphouse':
            return <AppGetHouse />;
        case 'sapbank':
            return <SapGetBank />;
        case 'sapGetCst':
            return <SapGetCustomerList />;
        case 'sapGetTrade':
            return <SapGetTrade />;
            case'getStatementFromFtp':
            return<Statement/>;

    }

    return <Fragment/>
}

    return (<div className='app-demo-platform'>
        <div className='app-demo-main' onScroll={handleScroll}>
            <div>
                <Menu onClick={e=>setCurrent(e.key)} selectedKeys={[current]} mode="horizontal">
                    <Menu.SubMenu title='APP'>
                        <Menu.Item key="appLogin">login(登录)</Menu.Item>
                        <Menu.Item key="getProject">getProject(获取项目列表)</Menu.Item>
                        <Menu.Item key="getFqList">getFqList(获取分期及楼栋信息)</Menu.Item>
                        <Menu.Item key="getDyList">getDyList(获取单元及房间信息)</Menu.Item>
                        <Menu.Item key="getFee">getFee(获取应收款)</Menu.Item>
                        <Menu.Item key="getZskFee">getZskFee(获取暂收款)</Menu.Item>
                        <Menu.Item key="getFund">getFund(收款)</Menu.Item>
                        <Menu.Item key="verifyPassword">verifyPassword(验证主管密码)</Menu.Item>
                        <Menu.Item key="getChinaPayRefKey">getChinaPayRefKey(获取PayRefKey)</Menu.Item>
                        <Menu.Item key="getStatementFromFtp">getStatementFromFtp(T+1手续费同步)</Menu.Item>
                    </Menu.SubMenu>
                    <Menu.SubMenu title='SAP'>
                        <Menu.Item key="saphouse">房源</Menu.Item>
                        <Menu.Item key="sapbank">入账银行</Menu.Item>
                        <Menu.Item key="sapGetCst">收款单/认筹单/签约(获取客户)</Menu.Item>

                        <Menu.Item key="sapGetTrade">收款单/认筹单/签约(获取交易单)</Menu.Item>
                        <Menu.Item key="stk">收款单/暂收款/服务费</Menu.Item>
                        <Menu.Item key="receipt">回传收据</Menu.Item>
                        <Menu.Item key="reverse">撤销收款</Menu.Item>
                       
                        <Menu.Item key="applet">调用SAP票据信息</Menu.Item>
                        <Menu.Item key="ticket">生成票据</Menu.Item>
                    </Menu.SubMenu>
                </Menu>
            </div>
            {renderDemo()}
        </div>
    </div>)
}


const handleScroll = () =>{
    AppPopover.close();
}


// WEBPACK FOOTER //
// ./src/posapi/PosApi.tsx